import { getApiCall, postApiCall } from "./tokenService";
import { IWorkHoursItem } from "../models/workTime/workHoursItem";
import { WorkHourSaveData } from "../models/workHour/workHourSaveData";

export const getCalculatedWorkHours = (
    employeeGroupId: string,
    employeeIds: string | string[],
    salaryPeriodId: string,
    calculateFillingHours = false,
    signal?: AbortSignal
): Promise<IWorkHoursItem[]> => {
    return getApiCall(
        `api/workhours?salaryPeriodId=${encodeURIComponent(salaryPeriodId)}${
            employeeGroupId
                ? `&employeeGroupId=${encodeURIComponent(employeeGroupId)}`
                : ""
        }&calculateFillingHours=${calculateFillingHours}${[employeeIds]
            .flat()
            .map((id) => `&employeeIds=${encodeURIComponent(id)}`)
            .join("")}`,
        null,
        signal
    );
};

export const getUpToDateWorkHours = (
    employeeId: string,
    salaryPeriodId: string,
    signal?: AbortSignal
): Promise<IWorkHoursItem[]> => {
    return getApiCall(
        `api/workhours/up-to-date?salaryPeriodId=${encodeURIComponent(
            salaryPeriodId
        )}&employeeId=${encodeURIComponent(employeeId)}`,
        null,
        signal
    );
};

export const getUpToDateNormalWorkHours = (
    employeeId: string,
    startDate: string,
    endDate: string,
    signal?: AbortSignal
): Promise<IWorkHoursItem[]> => {
    return getApiCall(
        `api/workhours/normal/up-to-date?startDate=${encodeURIComponent(
            startDate
        )}&endDate=${encodeURIComponent(
            endDate
        )}&employeeId=${encodeURIComponent(employeeId)}`,
        null,
        signal
    );
};

export const saveWorkHours = (data: WorkHourSaveData): Promise<void> => {
    return postApiCall<void>("api/workhour/save", null, JSON.stringify(data));
};
